"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Features = void 0;
var Features;
(function (Features) {
    Features["CustomFields"] = "custom-fields";
    Features["SafetyInstructions"] = "safety-instructions";
    Features["SignaturePad"] = "signature-pad";
})(Features = exports.Features || (exports.Features = {}));
